import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefaufgabe-entfernen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefaufgabeEntfernenEffects {

    PruefaufgabeEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFAUFGABE_ENTFERNEN),
        mergeMap((x: ac.PostPruefaufgabeEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefaufgabeEntfernen(x.pruefaufgabeRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefaufgabeEntfernenErfolgreichAction(result, x.pruefaufgabeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefaufgabeEntfernenFehlerAction(error, x.pruefaufgabeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
